var _style, _path, _path2, _path3, _g, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCarwash = function SvgCarwash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Carwash_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 75 75",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Carwash_svg__st0{fill-rule:evenodd;clip-rule:evenodd;fill:#262a30}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Carwash_svg__Fill-3",
    className: "Carwash_svg__st0",
    d: "M25.7 45.6c-1.1 0-1.9-.9-1.9-2s.9-2 1.9-2 1.9.9 1.9 2c.1 1.1-.8 2-1.9 2m0-5.6c-2 0-3.5 1.6-3.5 3.6s1.6 3.6 3.5 3.6 3.5-1.6 3.5-3.6c.1-2-1.5-3.6-3.5-3.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Carwash_svg__Fill-5",
    className: "Carwash_svg__st0",
    d: "M48.3 45.6c-1.1 0-1.9-.9-1.9-2s.9-2 1.9-2c1.1 0 1.9.9 1.9 2s-.9 2-1.9 2m0-5.6c-2 0-3.5 1.6-3.5 3.6s1.6 3.6 3.5 3.6c2 0 3.5-1.6 3.5-3.6S50.2 40 48.3 40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Carwash_svg__Fill-7",
    className: "Carwash_svg__st0",
    d: "M45.2 33.4H28.8c-.4 0-.8.4-.8.8s.4.8.8.8h16.4c.4 0 .8-.4.8-.8 0-.5-.4-.8-.8-.8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Carwash_svg__Group",
    transform: "translate(15.143 14.439)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Carwash_svg__Fill-9",
    className: "Carwash_svg__st0",
    d: "M25.9 26h-8.1c-.4 0-.8.4-.8.8s.4.8.8.8h8.1c.4 0 .8-.4.8-.8s-.3-.8-.8-.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Carwash_svg__Fill-11",
    className: "Carwash_svg__st0",
    d: "M25.9 30.3h-8.1c-.4 0-.8.4-.8.8s.4.8.8.8h8.1c.4 0 .8-.4.8-.8s-.3-.8-.8-.8"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "Carwash_svg__st0",
    d: "M49.8 36.4l-1.4-3.7c-.5.2-1 .3-1.6.3l1.2 3.4H26l3.1-8.7h9c-.2-.5-.4-1.1-.5-1.6h-9.1c-.3 0-.6.2-.8.5l-3.5 9.8h-.1c-4 0-7.2 3.3-7.2 7.3 0 3.9 3 7.1 6.8 7.2v3.5c0 1.8 1.4 3.2 3.2 3.2h1.7c1.8 0 3.2-1.4 3.2-3.2v-3.5H42v3.5c0 1.8 1.4 3.2 3.2 3.2H47c1.8 0 3.2-1.4 3.2-3.2v-3.5c3.8-.2 6.8-3.4 6.8-7.2 0-4.1-3.2-7.3-7.2-7.3zm-19.5 18c0 .9-.7 1.6-1.6 1.6H27c-.9 0-1.6-.7-1.6-1.6v-3.5h4.8l.1 3.5zm18.3 0c0 .9-.7 1.6-1.6 1.6h-1.7c-.9 0-1.6-.7-1.6-1.6v-3.5h4.8l.1 3.5zm1.2-5.1H24.2c-3.1 0-5.6-2.5-5.6-5.6s2.5-5.6 5.6-5.6H49.8c3.1 0 5.6 2.5 5.6 5.6 0 3-2.5 5.6-5.6 5.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2 27.4c1-1.9 1-4.1 0-6L45.9 12l-5.2 9.4c-1 1.9-1 4.1 0 6 1 1.8 2.8 3 4.9 3.1h.8c1.9-.1 3.7-1.3 4.8-3.1zm-1.6-.8c-.8 1.3-1.9 2-3.3 2.1h-.6c-1.4-.1-2.6-.9-3.3-2.1-.8-1.3-.8-2.9 0-4.2l3.5-6.4 3.5 6.4c1 1.3 1 2.9.2 4.2z",
    fill: "#262a30"
  })));
};
export default SvgCarwash;